// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>3</span>&nbsp;&nbsp;My mouth shall speak of wisdom&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;and my heart shall meditate on understanding.<br> </p> </div></div>";
// Exports
module.exports = code;